import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['vignetteSelect', 'variablesContainer', 'hint']
  static values = {
    vignettes: Object,
    currentVariables: Object
  }

  connect() {
    if (this.vignetteSelectTarget.value) {
      this.renderVariables()
    }
  }

  renderVariables() {
    const selectedId = parseInt(this.vignetteSelectTarget.value, 10)
    this.variablesContainerTarget.innerHTML = ''

    if (isNaN(selectedId)) {
      this.hintTarget.textContent =
        'Please select a vignette to configure variables.'
      this.hintTarget.classList.remove('hidden')
      return
    }

    let variables = this.vignettesValue[selectedId]

    if (typeof variables === 'string') {
      try {
        variables = JSON.parse(variables)
      } catch (e) {
        console.error('Failed to parse variables JSON:', e)
        variables = []
      }
    }

    if (!Array.isArray(variables)) {
      this.hintTarget.textContent = 'No variables found for this vignette.'
      this.hintTarget.classList.remove('hidden')
      return
    }

    variables.forEach((variable) => {
      const label = document.createElement('label')
      label.textContent = variable
      label.className = 'block text-sm font-medium text-gray-900 mt-4'

      const input = document.createElement('input')
      input.name = `jurisdiction_vignette_variation[variables][${variable}]`
      input.type = 'text'
      input.value = this.currentVariablesValue?.[variable] || ''
      input.className =
        'mt-1 block w-full rounded-md bg-white px-3 py-1.5 text-sm text-gray-900 outline-1 outline-gray-300 focus:outline-2 focus:outline-indigo-600'

      this.variablesContainerTarget.appendChild(label)
      this.variablesContainerTarget.appendChild(input)
    })

    this.hintTarget.classList.add('hidden')
  }
}
